import { getOneMinuteGramsDifference } from './alcoholGrams';

export const getTimeToSoberMinutes = (weight: number, alcoholGrams: number) => {
    const oneMinuteDiff = getOneMinuteGramsDifference(weight);
    return alcoholGrams / oneMinuteDiff;
};

export const getTimeToRide = (timeToSoberMinutes: number) => {
    return (timeToSoberMinutes / 60) * 1.33;
};
